<img [src]="emojiImage" [alt]="id" class="ql-emoji" [title]="id">